document.addEventListener("DOMContentLoaded", function () {
    const ajaxurl = ajax_object.ajax_url;
    let current_page =
        new URLSearchParams(window.location.search).get("paged") || 1;
    let current_category =
        new URLSearchParams(window.location.search).get("category") || "all";

    function loadInsights(page = 1, category = "all") {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", ajaxurl, true);
        xhr.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8"
        );
        xhr.onload = function () {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                document.getElementById("insights-container").innerHTML =
                    response.posts;
                document.getElementById("pagination-container").innerHTML =
                    response.pagination;
                document.getElementById(
                    "mobile-pagination-container"
                ).innerHTML = response.mobile_pagination;
                current_page = page;
                current_category = category;
                attachPaginationListeners();
                updateURLParameter("paged", page);
                updateURLParameter("category", category);
                updateActiveFilterButton(category);

                // Scroll to the navigation
                scrollToNavigation();
            }
        };
        xhr.send(
            "action=filter_insights&page=" + page + "&category=" + category
        );
    }

    function scrollToNavigation() {
        // Assuming the navigation is within an element with class 'title-buttons-wrapper'
        const navigationElement = document.querySelector(".mobile-pagination");
        if (navigationElement) {
            navigationElement.scrollIntoView({
                behavior: "instant",
                block: "center",
            });
        }
    }

    function attachPaginationListeners() {
        const paginationLinks = document.querySelectorAll(
            "#pagination-container a.page-numbers, #mobile-pagination-container a.nav-button"
        );
        paginationLinks.forEach(function (link) {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const url = new URL(this.href);
                const pageNum = url.searchParams.get("paged") || 1;
                const category =
                    url.searchParams.get("category") || current_category;
                loadInsights(parseInt(pageNum), category);
            });
        });
    }

    function updateURLParameter(key, value) {
        const url = new URL(window.location);
        url.searchParams.set(key, value);
        window.history.pushState({}, "", url);
    }

    function updateActiveFilterButton(category) {
        const filterButtons = document.querySelectorAll(".filter-button");
        filterButtons.forEach(function (btn) {
            btn.classList.remove("active");
            if (btn.getAttribute("data-category") === category) {
                btn.classList.add("active");
            }
        });
    }

    const filterButtons = document.querySelectorAll(".filter-button");
    filterButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            const category = this.getAttribute("data-category");
            loadInsights(1, category);
        });
    });

    loadInsights(current_page, current_category);
    attachPaginationListeners(); // Add this line to attach listeners on initial load
});
